var scope_0 = require('/opt/build/repo/documentation/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/40eae2405c355225d07cef015dd58632.js').default;

var scope_1 = require('/opt/build/repo/documentation/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/5773867a9d22729f0af08329f92d84bf.js').default;

var scope_2 = require('/opt/build/repo/documentation/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/66f8206d8353745620d1229fbc9fdabb.js').default;

var scope_3 = require('/opt/build/repo/documentation/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/8d284d556764132a2494554055b5b60f.js').default;

var scope_4 = require('/opt/build/repo/documentation/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/9ca905d35e58a285c4778f88279b3d84.js').default;

var scope_5 = require('/opt/build/repo/documentation/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/9e8540ac85fe8870d77787dbdfcadfe7.js').default;

var scope_6 = require('/opt/build/repo/documentation/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/a81fc2a9317c3350293bebf2823da5af.js').default;

var scope_7 = require('/opt/build/repo/documentation/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/b5c21c78d51c10c63cab142f3bea8f1b.js').default;

var scope_8 = require('/opt/build/repo/documentation/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/e92f8988d65cf25c087d226e6c0ef06f.js').default;

export default Object.assign({}, scope_0, scope_1, scope_2, scope_3, scope_4, scope_5, scope_6, scope_7, scope_8);